import React, { useEffect, useState } from 'react';
import { makeStyles, Container, Grid } from '@material-ui/core';
import {
  BackNavAdmin,
  CurationTitle,
  CurationFilters,
  CurationTable,
  CurationMenus,
  CurationCard,
  Loading
} from '../../components';
import InfiniteScroll from 'react-infinite-scroll-component';
import { curationActions, ideaActions } from '../../actions';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useWindowSize } from '../../hooks';
import config from '../../config';

import ListIcon from '@material-ui/icons/List';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: theme.spacing(4),
  },
}));

function CurationIdeasListPage(props) {
  const classes = useStyles();
  const [width] = useWindowSize();
  const dispatch = useDispatch();
  const {
    ideas,
    loading,
    paging,
    paging: { statusCode, page, sort, query, limit },
    filters
  } = useSelector((state) => state.curation);
  const { t } = useTranslation();
  const [newIdeas, setNewIdeias] = useState([])

  useEffect(() => {
    dispatch(curationActions.clearFilters());
  }, []);

  useEffect(() => {
    setNewIdeias(ideas)
  }, [ideas])

  useEffect(() => {
    dispatch(curationActions.filterIdeas(filters));
  }, [dispatch, limit, page, query, sort, statusCode]);



  function loadMoreIdeas() {
    if (!loading) {
      var newPage = page === 1 ? 2 : page;
      dispatch(
        curationActions.getIdeasMobile(
          newPage,
          sort,
          query,
          limit,
          statusCode
        )
      );
    }
  }

  function renderTable() {
    return (
      <>
        {newIdeas?.length > 0 && <CurationTable ideas={newIdeas} paging={paging} loading={loading} />}
      </>
    );
  }

  function renderCards() {
    if (newIdeas?.length > 0) {
      return (
        <InfiniteScroll
          dataLength={newIdeas.length}
          next={loadMoreIdeas}
          hasMore={true}
          scrollThreshold={'100%'}
          loader={
            loading && (
              <div className={classes.containerLoading}>
                <Loading />
              </div>
            )
          }
        >
          {newIdeas.map((newIdeas, index) => (
            <CurationCard
              key={index}
              index={index}
              ideas={newIdeas}
              paging={paging}
              setNewIdeias={setNewIdeias}
            />
          ))}
        </InfiniteScroll>
      );
    }

    return null;
  }

  return (
    <>
      <BackNavAdmin title={t('curadoria')} />
      <Container maxWidth="lg" className={classes.root}>
        <CurationMenus />
        <CurationTitle
          title={t('lista_de_ideias')}
          icon={<ListIcon color="primary" />}
          info={t('na_listagem_e_possivel_visualizar_todas_as_ideias_filtrando_as_por_status_e_por_nome_ou_desafio')}
        />
        <CurationFilters list={true} statusCode={statusCode} paging={paging} />
        <Grid container>
          <Grid item xs={12}>
            {width > config.RESPONSIVE_MOBILE ? renderTable() : renderCards()}
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export { CurationIdeasListPage };
